// ======================================================================
// File Name       : archivement
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getUserList(param) {
  return commonCallApi({
    path: 'user/GetList',
    data: param,
  });
}

export function getAuthorityList(param) {
  return commonCallApi({
    path: 'userAuthority/GetList',
    data: param,
  });
}


export function getReportOperationCount(param) {
  return commonCallApi({
    path: 'reportOperation/Count',
    data: param,
  });
}

export function getReportOperationList(param) {
  return commonCallApi({
    path: 'reportOperation/GetList',
    data: param,
  });
}
